import { render } from "./ClusterMonitoringView.vue?vue&type=template&id=2d643906&scoped=true&ts=true"
import script from "./ClusterMonitoringView.vue?vue&type=script&lang=ts"
export * from "./ClusterMonitoringView.vue?vue&type=script&lang=ts"

import "./ClusterMonitoringView.vue?vue&type=style&index=0&id=2d643906&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d643906"]])

export default __exports__